import React, { useState, useEffect } from "react";

import styled from "styled-components";
import Colors from "../../../shared/colors";
import moment from "moment";

import LocalStorage from "../../../shared/localStorage";
import { typeOfPAF } from "../../../constants/typeOfPAF";
import { registrationCategory } from "../../../constants/register.constants";
import { verifyUserTypeConnectedRegistrar } from "../../../shared/helpers";

const Layout = styled.div`
  background: white;
  padding: 15px;
  .patients-wrapper-container {
    .row {
      padding: 7px 0px;
    }
    .col {
      padding-left: 0;
      padding-right: 0;
    }

    label {
      color: ${Colors.aquaDeep};
    }
  }

  table {
    margin: 0 auto;
    width: 80%;
  }

  td,
  th {
    border: 1px solid ${Colors.alto};
    text-align: center;
    padding: 8px;
    font-weight: normal;

    @media screen and (max-width: 850px) {
      padding: 6px;
    }
  }

  td:first-child,
  th:first-child {
    text-align: left;
    color: ${Colors.aquaDeep};
  }

  .container {
    padding-left: var(--bs-gutter-x, 0.75rem);
    padding-right: var(--bs-gutter-x, 0.75rem);
  }

  .edit-option {
    margin-left: 10px;
    color: #d73131;
    text-decoration: underline;
    cursor: pointer;
  }

  .mt-2 {
    input {
      margin-top: 10px;
      margin-bottom: 15px;
      background-color: #f8f8f8;
      color: ${Colors.doveGray} !important;
      border: 0;
      border-bottom: 1px solid ${Colors.silver};
      font-size: 20px;
      line-height: 22px;
      height: 30px;
    }
  }
`;

const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
const parseLocalStorage = JSON.parse(getLocalStorage);

const ViewPAF = ({ form, isPrescriber, personalDetails, isRenewal, index }) => {
  const [isFirst, setIsFirst] = useState();
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR
  );

  useEffect(() => {
    totalCapsulesFirst();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  const displayConditionallyApprovedBy = () => {
    if (form?.approved_or_rejected_by == null) {
      return "Awaiting approval";
    }
    return form?.approved_or_rejected_by;
  };

  const summaryPAF = () => {
    const displayNumberOfCycles =
      form?.patient_type === 1
        ? "1 "
        : form?.number_cycles?.label?.split(" ")[0] ||
          form?.n_cycles?.split(" ")[0];

    return (
      <h2>
        PAF {index} -{" "}
        <span className="font-size-18 blue-label">{`Lenalidomide`}</span>{" "}
        {`${form?.capsule_strength || ""}`}mg X{" "}
        {`${displayNumberOfCycles} Cycle`}
      </h2>
    );
  };

  const displayConditionallyIndication = () => {
    if (form?.indication_other) {
      return `Other: (${form?.indication_other})`;
    } else {
      return form?.indication?.label || form?.indication;
    }
  };

  const displayConditionallyCapsulesPerCycle = (property, otherProperty) => {
    if (form[property]?.value === 0 || form[property] === 0) {
      return `Other(${form[otherProperty]}) Capsules`;
    } else if (+form[property] > 0) {
      return form[property] + " Capsules";
    } else if (form[property]?.value > 0) {
      return form[property].value + " Capsules";
    }
  };

  const displayConditionallyNumberOfCycles = () => {
    return form?.number_cycles?.label
      ? form?.number_cycles?.label
      : form?.number_cycles || form?.n_cycles;
  };

  const calculateCapsuleQuantity = (property, otherProperty) => {
    let capsulesPerCycleValue;
    if (form[property]?.value === 0 || form[property] === 0) {
      capsulesPerCycleValue = form[otherProperty];
    } else if (+form[property] > 0) {
      capsulesPerCycleValue = form[property];
    } else if (form[property]?.value > 0) {
      capsulesPerCycleValue = form[property].value;
    } else return "";

    const numberOfCycles = !isNaN(form?.number_cycles)
      ? form?.number_cycles
      : form?.number_cycles?.label.split(" ")[0] ||
        form?.n_cycles.split(" ")[0];
    return +capsulesPerCycleValue * numberOfCycles;
  };

  const getPatientCategory = () => {
    const patientType =
      form?.patient_type === undefined
        ? form?.patient?.patient_type
        : form?.patient_type;

    if (patientType === "Male" || patientType === typeOfPAF.MALE) {
      return "Male";
    } else if (
      patientType === "Woman of Non-Childbearing Potential" ||
      patientType === typeOfPAF.WOMANOFNCP
    ) {
      return "Woman of Non-Childbearing Potential";
    } else {
      return "Woman of Childbearing Potential";
    }
  };

  const totalCapsulesFirst = () => {
    if (
      !!form?.capsule_per_cycle_5 ||
      !!form?.capsule_cycle_5 ||
      form?.capsule_cycle_5 === 0
    ) {
      setIsFirst("capsule_cycle_5");
    } else if (
      !!form?.capsule_per_cycle_10 ||
      !!form?.capsule_cycle_10 ||
      form?.capsule_cycle_10 === 0
    ) {
      setIsFirst("capsule_cycle_10");
    } else if (
      !!form?.capsule_per_cycle_15 ||
      !!form?.capsule_cycle_15 ||
      form?.capsule_cycle_15 === 0
    ) {
      setIsFirst("capsule_cycle_15");
    } else if (
      !!form?.capsule_per_cycle_20 ||
      !!form?.capsule_cycle_20 ||
      form?.capsule_cycle_20 === 0
    ) {
      setIsFirst("capsule_cycle_20");
    } else if (
      !!form?.capsule_per_cycle_25 ||
      !!form?.capsule_cycle_25 ||
      form?.capsule_cycle_25 === 0
    ) {
      setIsFirst("capsule_cycle_25");
    }
  };

  const popualateprescribingPhisician = () => {
    if (isPrescriber || isConnectedRegistrar) {
      if (!isRenewal) {
        if (personalDetails) {
          return (
            (personalDetails?.first_name || "") +
            " " +
            (personalDetails?.last_name || "")
          );
        } else {
          if (form?.prescriber) {
            return (
              (form?.prescriber?.first_name || "") +
              " " +
              (form?.prescriber?.last_name || "")
            );
          } else if (form?.registrar) {
            return (
              (form?.registrar?.first_name || "") +
              " " +
              (form?.registrar?.last_name || "")
            );
          } else {
            return form?.prescriber_name || "";
          }
        }
      } else {
        return (
          (personalDetails?.first_name || "") +
          " " +
          (personalDetails?.last_name || "")
        );
      }
    } else {
      if (!!form?.prescriber_name || !!form?.prescriber) {
        return (
          form?.prescriber_name ||
          "" ||
          (form?.prescriber?.first_name || "") +
            " " +
            (form?.prescriber?.last_name || "")
        );
      } else {
        return (
          (form?.registrar?.first_name || "") +
          " " +
          (form?.registrar?.last_name || "")
        );
      }
    }
  };

  const truncateAddress = (address) => {
    return address?.slice(address?.indexOf(",") + 1);
  };

  const populateHospitalAddress = () => {
    if (isPrescriber || isConnectedRegistrar) {
      return !isRenewal
        ? personalDetails?.hospital?.address?.full_address ||
            truncateAddress(form?.prescriber?.name_and_address_hospital) ||
            truncateAddress(form?.registrar?.name_and_address_hospital)
        : truncateAddress(form?.name_and_address_hospital) ||
            form?.name_and_address_hospital;
    } else {
      if (form?.name_and_address_hospital) {
        return (
          truncateAddress(form?.name_and_address_hospital) ||
          form?.name_and_address_hospital
        );
      } else if (form?.prescriber?.name_and_address_hospital) {
        return (
          truncateAddress(form?.prescriber?.name_and_address_hospital) ||
          form?.prescriber?.name_and_address_hospital
        );
      } else {
        return (
          truncateAddress(form?.registrar?.name_and_address_hospital) ||
          truncateAddress(personalDetails?.hospital?.address?.full_address)
        );
      }
    }
  };

  const displayCreatedByRole = () => {
    if (form.prescriber) {
      return "Prescribing Physician:";
    } else if (form.registrar) {
      return "Connected Registrar";
    } else {
      return isConnectedRegistrar
        ? "Connected Registrar"
        : "Prescribing Physician:";
    }
  };

  return form ? (
    <Layout>
      <h2 style={{ paddingTop: "20px" }}>Patient Details</h2>
      <div className="container patients-wrapper-container">
        <div className="row">
          <div className="col">
            <label>Patient Category:</label>
            <div className="font-size-16">{getPatientCategory()}</div>
          </div>

          {getPatientCategory() === "Woman of Childbearing Potential" ? (
            <div className="col">
              <label>Last Negative Pregnancy Test:</label>

              <div className="font-size-16">
                {form.patient_pregnancy_test
                  ? moment(form.patient_pregnancy_test).format("DD / MM / YY")
                  : moment(form.patient.patient_pregnancy_test).format(
                      "DD / MM / YY"
                    )}
              </div>
            </div>
          ) : (
            <div className="col"></div>
          )}
        </div>
        <div className="row">
          <div className="col">
            <label>Indication:</label>
            <div className="font-size-16">
              {displayConditionallyIndication()}
            </div>
          </div>
          <div className="col">
            <label>Molecule:</label>
            <div className="font-size-16">Lenalidomide</div>
          </div>
          <div className="col">
            <label>High Tech Prescription Date:</label>
            <div className="font-size-16">
              {moment(form?.high_tech_prescription_date).format("DD / MM / YY")}
            </div>
          </div>
          <div className="col">
            <React.Fragment>
              <label>Date of PAF:</label>
              <div className="font-size-16">
                <div className="font-size-16">
                  {moment(form?.date_paper_paf || form?.pfa_issued).format(
                    "DD / MM / YY"
                  )}
                </div>
              </div>
            </React.Fragment>
          </div>
        </div>
      </div>

      <hr className="green-hr" />

      {summaryPAF()}
      <div className="container patients-wrapper-container mb-2">
        <div className="row">
          <div className="col">
            <label>Capsule Strength:</label>
          </div>
          <div className="col">
            <label>Capsules per Cycle:</label>
          </div>
          <div className="col">
            <label>Number of Cycles:</label>
          </div>
          <div className="col">
            <label>Total Capsules:</label>
          </div>
        </div>
        {(!!form?.capsule_per_cycle_5 ||
          !!form?.capsule_cycle_5 ||
          form?.capsule_cycle_5 === 0) && (
          <div className="row">
            <div className="col">
              <div className="font-size-16">5mg</div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {!!form?.capsule_per_cycle_5
                  ? displayConditionallyCapsulesPerCycle(
                      "capsule_per_cycle_5",
                      "capsule_cycle_other_5"
                    )
                  : displayConditionallyCapsulesPerCycle(
                      "capsule_cycle_5",
                      "capsule_cycle_other_5"
                    )}
              </div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {displayConditionallyNumberOfCycles()}
              </div>
            </div>
            <div className="col">
              {isFirst === "capsule_cycle_5" && (
                <div className="font-size-16">
                  {form?.total_capsules} Capsules
                </div>
              )}
            </div>
          </div>
        )}
        {(!!form?.capsule_per_cycle_10 ||
          !!form?.capsule_cycle_10 ||
          form?.capsule_cycle_10 === 0) && (
          <div className="row">
            <div className="col">
              <div className="font-size-16">10mg</div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {!!form?.capsule_per_cycle_10
                  ? displayConditionallyCapsulesPerCycle(
                      "capsule_per_cycle_10",
                      "capsule_cycle_other_10"
                    )
                  : displayConditionallyCapsulesPerCycle(
                      "capsule_cycle_10",
                      "capsule_cycle_other_10"
                    )}
              </div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {displayConditionallyNumberOfCycles()}
              </div>
            </div>
            <div className="col">
              {isFirst === "capsule_cycle_10" && (
                <div className="font-size-16">
                  {form?.total_capsules} Capsules
                </div>
              )}
            </div>
          </div>
        )}
        {(!!form?.capsule_per_cycle_15 ||
          !!form?.capsule_cycle_15 ||
          form?.capsule_cycle_15 === 0) && (
          <div className="row">
            <div className="col">
              <div className="font-size-16">15mg</div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {!!form?.capsule_per_cycle_15
                  ? displayConditionallyCapsulesPerCycle(
                      "capsule_per_cycle_15",
                      "capsule_cycle_other_15"
                    )
                  : displayConditionallyCapsulesPerCycle(
                      "capsule_cycle_15",
                      "capsule_cycle_other_15"
                    )}
              </div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {displayConditionallyNumberOfCycles()}
              </div>
            </div>
            <div className="col">
              {isFirst === "capsule_cycle_15" && (
                <div className="font-size-16">
                  {form?.total_capsules} Capsules
                </div>
              )}
            </div>
          </div>
        )}
        {(!!form?.capsule_per_cycle_20 ||
          !!form?.capsule_cycle_20 ||
          form?.capsule_cycle_20 === 0) && (
          <div className="row">
            <div className="col">
              <div className="font-size-16">20mg</div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {!!form?.capsule_per_cycle_20
                  ? displayConditionallyCapsulesPerCycle(
                      "capsule_per_cycle_20",
                      "capsule_cycle_other_20"
                    )
                  : displayConditionallyCapsulesPerCycle(
                      "capsule_cycle_20",
                      "capsule_cycle_other_20"
                    )}
              </div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {displayConditionallyNumberOfCycles()}
              </div>
            </div>
            <div className="col">
              {isFirst === "capsule_cycle_20" && (
                <div className="font-size-16">
                  {form?.total_capsules} Capsules
                </div>
              )}
            </div>
          </div>
        )}
        {(!!form?.capsule_per_cycle_25 ||
          !!form?.capsule_cycle_25 ||
          form?.capsule_cycle_25 === 0) && (
          <div className="row">
            <div className="col">
              <div className="font-size-16">25mg</div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {!!form?.capsule_per_cycle_25
                  ? displayConditionallyCapsulesPerCycle(
                      "capsule_per_cycle_25",
                      "capsule_cycle_other_25"
                    )
                  : displayConditionallyCapsulesPerCycle(
                      "capsule_cycle_25",
                      "capsule_cycle_other_25"
                    )}
              </div>
            </div>
            <div className="col">
              <div className="font-size-16">
                {displayConditionallyNumberOfCycles()}
              </div>
            </div>
            <div className="col">
              {isFirst === "capsule_cycle_25" && (
                <div className="font-size-16">
                  {form?.total_capsules} Capsules
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <table>
        <thead>
          <tr>
            <th>Capsule strength</th>
            <th>5mg</th>
            <th>10mg</th>
            <th>15mg</th>
            <th>20mg</th>
            <th>25mg</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Capsule Quantity</td>
            <td>
              {!!form.capsule_per_cycle_5
                ? calculateCapsuleQuantity(
                    "capsule_per_cycle_5",
                    "capsule_cycle_other_5"
                  )
                : !!form.n_cycles &&
                  calculateCapsuleQuantity(
                    "capsule_cycle_5",
                    "capsule_cycle_other_5"
                  )}
            </td>
            <td>
              {!!form.capsule_per_cycle_10
                ? calculateCapsuleQuantity(
                    "capsule_per_cycle_10",
                    "capsule_cycle_other_10"
                  )
                : !!form.n_cycles &&
                  calculateCapsuleQuantity(
                    "capsule_cycle_10",
                    "capsule_cycle_other_10"
                  )}
            </td>
            <td>
              {!!form.capsule_per_cycle_15
                ? calculateCapsuleQuantity(
                    "capsule_per_cycle_15",
                    "capsule_cycle_other_15"
                  )
                : !!form.n_cycles &&
                  calculateCapsuleQuantity(
                    "capsule_cycle_15",
                    "capsule_cycle_other_15"
                  )}
            </td>
            <td>
              {!!form.capsule_per_cycle_20
                ? calculateCapsuleQuantity(
                    "capsule_per_cycle_20",
                    "capsule_cycle_other_20"
                  )
                : !!form.n_cycles &&
                  calculateCapsuleQuantity(
                    "capsule_cycle_20",
                    "capsule_cycle_other_20"
                  )}
            </td>
            <td>
              {!!form.capsule_per_cycle_25
                ? calculateCapsuleQuantity(
                    "capsule_per_cycle_25",
                    "capsule_cycle_other_25"
                  )
                : !!form.n_cycles &&
                  calculateCapsuleQuantity(
                    "capsule_cycle_25",
                    "capsule_cycle_other_25"
                  )}
            </td>
          </tr>
        </tbody>
      </table>

      <hr className="green-hr" />

      <div className="container patients-wrapper-container">
        <div className="row">
          <div className="col">
            <label>{displayCreatedByRole()}</label>
            <div className="font-size-16">
              {popualateprescribingPhisician()}
            </div>
          </div>
          <div className="col">
            <label>Hospital Address:</label>
            <div className="font-size-16">{populateHospitalAddress()}</div>
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col">
            <label>
              {form?.status === "Rejected" ? "Rejected By:" : "Approved By:"}
            </label>
            <div className="font-size-16">
              {displayConditionallyApprovedBy()}
            </div>
          </div>
          <div className="col">
            <label>Pharmacy Address:</label>
            <div className="font-size-16">
              {form?.pharmacy_address ??
                form?.pharmacy_id?.address ??
                parseLocalStorage?.pharmacy?.address?.full_address ??
                form?.pharmacy_id?.label}
            </div>
          </div>
          <div className="col" />
        </div>
      </div>
    </Layout>
  ) : (
    ""
  );
};
export default ViewPAF;
